var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPositioning = function SvgPositioning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      boxShadow: "0 0 7px #ccc",
      borderRadius: 10,
      margin: 10
    },
    viewBox: "0 0 52 52"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "#fff",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1F4970",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m12.5 12.5 7.5 7.425M12.5 12.5v6.75m0-6.75h6.75M12.5 39.425 20 32m19.5 7.425L32.075 32m7.35-19.5L32 19.925m.75-7.425h6.75v6.75m0 13.5v6.75h-6.75m-13.5 0H12.5v-6.75"
  })));
};
export default SvgPositioning;